import React, { useEffect, useState } from 'react';
import { Row, Col, Input, Form, Dropdown } from 'antd';
import CustomBreadcrumb from './CustomBreadcrumb';
import {
  SearchOutlined,
  EnvironmentOutlined,
  NumberOutlined,
  CarOutlined,
  TeamOutlined,
  EditOutlined,
  DownOutlined,
  ArrowLeftOutlined,
} from '@ant-design/icons';
import { FormInstance } from 'antd/lib/form';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { useLocation, useNavigate } from 'react-router-dom';
import { FilterConfig, FilterValues } from 'types';
import Filter from './FiltreSFS';
import IPen from 'icons/IPen';

interface HeroTitleProps {
  className?: string;
  form: FormInstance;
  display?: boolean;
  title?: string;
  color: string;
  itemsCompanyHierarchyTree?: any[];
  onEdit?: () => void;
  isEditing?: boolean;
  tptype?: string;
  showFilter?: boolean;
  filterConfig?: FilterConfig[];
  onFilterSearch?: (values: FilterValues) => void;
  onFilterReset?: () => void;
  noTitleOverlay?: boolean;
  titleDisplay?: string,
  prev?: boolean;
  prevTab?: any;
}

const HeroTitle: React.FC<HeroTitleProps> = ({
  className,
  form,
  display,
  title,
  titleDisplay,
  color,
  itemsCompanyHierarchyTree,
  onEdit,
  isEditing,
  tptype,
  showFilter = false,
  filterConfig = [],
  onFilterSearch,
  onFilterReset,
  noTitleOverlay, 
  prev = false,
  prevTab
}) => {
  const navigate = useNavigate();
  const [isFilterOpen, setIsFilterOpen] = useState(true);
  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };
  const handleFilterSearch = (values: FilterValues) => {
    if (onFilterSearch) {
      onFilterSearch(values)
    }
  }

  const handleFilterReset = () => {
    if (onFilterReset) {
      onFilterReset()
    }
  }
  // tpmainadrstreet1: thirdParty?.address?.tpmainadrstreet1,
  // tpmainadrstreet2: thirdParty?.address?.tpmainadrstreet2,
  // tpmainadrcity: thirdParty?.address?.tpmainadrcity,
  // tpmainadrzipcode: thirdParty?.address?.tpmainadrzipcode,
  // tpmainadrregion: thirdParty?.address?.tpmainadrregion,
  // tpmainadrregionglobale: thirdParty?.address?.tpmainadrregionglobale,
  // tpmainadrcountry: thirdParty?.address?.tpmainadrcountry,
  return (
    <div className={`ut-title-page ut-title-page-${color} ut-title-page-${className}  ${className || ''} ${noTitleOverlay ? 'no-after' : ''}`}>
      <Row>
        <Col span={17} className="d-flex align-center justify-start">

        {prev && (
          
            <ArrowLeftOutlined
          className="text-white font-size-24 floatLeft returnIcon mr-3 "
          onClick={() => navigate(-1)}
        /> )}
        {prevTab && (
          
            <ArrowLeftOutlined
          className="text-white font-size-24 floatLeft returnIcon mr-3 "
          onClick={() => navigate(prevTab)}
        /> )}
         <Row>
            <Col span={24}>
            <CustomBreadcrumb
              items={itemsCompanyHierarchyTree}
              className="ut-custom-breadcrumb font-size-13"
            />
            </Col>
            <Col span={24}>
            <div className="d-flex flex-row align-start">
            <div className="font-size-32 text-white d-flex flex-row">
              {titleDisplay ? (
              <div>
                {titleDisplay}
              </div>
              ) : !display ? (
              <div>
                {form.getFieldValue('tpname')}
              </div>
              ) : (
              <GetLabel label={title ?? ''} />
              )}
              {!display && (
              <IPen
                width={40}
                height={40}
                color="#FFFFFF8F"
                onClick={() => {
                navigate(
                  `/thirdparty-sfs/${form.getFieldValue(
                  'tpid'
                  )}/${form.getFieldValue('tptype')}/update`
                );
                }}
                className="mt-3 ml-1"
              />
              )}
            </div>
            </div>
            </Col>
          </Row>
        </Col>
        <Col span={7} className="d-flex align-center justify-end">
          {!display && (
            <Input
              className="ut-input-search ut-input-search-consulting"
              addonAfter={<SearchOutlined />}
              placeholder="Rechercher un VIN, une facture, un contrat"
            />
          )}
          {showFilter && (
            <div className="cursor-pointer">
              <DownOutlined
                rotate={isFilterOpen ? 180 : 0}
                onClick={toggleFilter}
                className="font-size-20 text-white"
              />
            </div>
          )}
        </Col>
      </Row>
      {showFilter && isFilterOpen && (
        <div className="filter-display w-full mt-4">
          <Filter
            form={form}
            filters={filterConfig}
            onSearch={handleFilterSearch} onReset={handleFilterReset}
          />
        </div>
      )}
      <Row className="align-center">
        <Col span={22}></Col>
      </Row>
      {!display && (
        <Row className="d-flex justify-between align-center mt-1 z-index-1 position-relative">
          <Col span={4}>
            <Row>
              <Col span={3} style={{ display: 'flex' }}>
                <div className="d-flex align-center">
                  <span className="font-size-20 text-light pr-2">
                    <EnvironmentOutlined />
                  </span>
                </div>
              </Col>

              <Col span={20}>
                <Row>
                  <Col span={24}>
                    <div className="d-flex align-center">
                      <p className="font-size-15 text-white">
                        {form.getFieldValue('tpmainadrstreet1')}
                      </p>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="d-flex align-center">
                      <p className="font-size-15 text-white">
                        {form.getFieldValue('tpmainadrzipcode') +
                          ' - ' +
                          form.getFieldValue('tpmainadrcitylabel') +
                          ' - ' +
                          form.getFieldValue('tpmainadrcountrylabel') +
                          ''}
                      </p>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={5}>
            <div className="d-flex align-center">
              <span className="font-size-20 text-light pr-2">
                <NumberOutlined />
              </span>
              <div className="d-flex flex-column">
                <p className="font-size-15 text-white">
                  <GetLabel
                    label={
                      form.getFieldValue('tptype') === 'CONC'
                        ? 'rrdi'
                        : 'reference'
                    }
                  />
                </p>
                <p className="font-size-15 text-white">
                  {form.getFieldValue('tpreference')}
                </p>
              </div>
            </div>
          </Col>
          {form.getFieldValue('tptype') != "SPM" && <Col span={4}>
            <div className="d-flex align-center">
              <span className="font-size-20 text-light pr-2">
                <NumberOutlined />
              </span>
              <div className="d-flex flex-column">
                <p className="font-size-15 text-white">
                  <GetLabel label="tpfiscalid" />
                </p>
                <p className="font-size-15 text-white">
                  {form.getFieldValue('tpfiscalid')}
                </p>
              </div>
            </div>
          </Col>}
          <Col span={6}>
            <div className="d-flex align-center">
              <span className="font-size-20 text-light pr-2">
                <CarOutlined />
              </span>
              <div className="d-flex flex-column">
                <p className="font-size-15 text-white">
                  <GetLabel label="tpbrand" />
                </p>
                <p className="font-size-15 text-white">
                  {form.getFieldValue('tpbrand')}
                </p>
              </div>
            </div>
          </Col>
          {form.getFieldValue('tptype') != "SPM" &&
            <Col span={4}>
              <div className="d-flex align-center">
                <span className="font-size-20 text-light pr-2">
                  <TeamOutlined />
                </span>
                <div className="d-flex flex-column">
                  <p className="font-size-15 text-white">
                    <GetLabel label="tptype" />
                  </p>
                  <p className="font-size-15 text-white">
                    {form.getFieldValue('tptype')}
                  </p>
                </div>
              </div>
            </Col>}
        </Row>
      )}
    </div>
  );
};

export default HeroTitle;
